import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { darken } from 'polished';

import SlideToggle from './helpers/SlideToggle';
import breakpoints from '../styles/breakpoints';
import { arrowUpIcon, arrowDownIcon } from '../media/icons';

import RawHTML from './helpers/RawHTML';

const StyledAccordionItem = styled.div`
  overflow: hidden;
`;

const Heading = styled.div`
  background-color: ${p =>
    p.isOpen ? darken(0.1, p.theme.colors.lightBg) : p.theme.colors.lightBg};
  background-image: url(${p => (p.isOpen ? arrowUpIcon : arrowDownIcon)});
  background-position: 97% 50%;
  background-repeat: no-repeat;
  background-size: 14px 14px;
  color: ${p => p.theme.colors.lightFont};
  cursor: pointer;
  font-size: 1rem;
  font-weight: 500;
  line-height: 1;
  margin-bottom: 10px;
  padding: 23px 55px 23px 19px;
  transition: background-color 0.5s;

  ${breakpoints.medium`
    font-size: 1.125rem;
  `};

  &:hover {
    background-color: #e7eaed;
  }
`;

const Content = styled.div`
  color: ${p => p.theme.colors.lightFont};
  font-size: 1.25rem;
  font-weight: 300;
  line-height: 2;
  margin-bottom: 30px;
  padding: 20px;

  h2 {
    margin: 0 0 23px 0;
  }
`;

export default class AccordionItem extends Component {
  static propTypes = {
    heading: PropTypes.string.isRequired,
    content: PropTypes.string.isRequired
  };

  constructor(props) {
    super(props);

    this.state = {
      isOpen: false
    };
  }

  render() {
    const { isOpen } = this.state;
    const { heading, content } = this.props;

    return (
      <StyledAccordionItem>
        <Heading
          isOpen={isOpen}
          onClick={() => this.setState({ isOpen: !isOpen })}
        >
          {heading}
        </Heading>

        <SlideToggle in={isOpen}>
          {isOpen && <Content>
            <RawHTML html={content} />
          </Content>}
        </SlideToggle>
      </StyledAccordionItem>
    );
  }
}
